import { Link } from "react-router-dom";
import dollars from "../../assets/dollars.svg";
import people from "../../assets/people.svg";
import wagon from "../../assets/wagon.svg";

function Landing() {
  return (
    <>
      <div className="container col-xxl-8 px-4 py-5">
        <div
          className="position-relative px-4 py-5 my-3"
          style={{ height: "100vh" }}
        >
          <div className="container position-absolute top-50 start-50 translate-middle">
            <h1 className="lead display-1 text-primary lh-1 mb-3">
              The 49 Plan
            </h1>
            <h2 className="text-light fw-semibold">Provide and Pioneer</h2>
            <h3 className="text-light">
              A lot of Mountaineers now live in the other 49 states, but many of
              them still call the Mountain State home. We believe they would
              love to hear some good news from their homeplace.
            </h3>
            <div className="mt-5">
              <Link
                to={"/map"}
                className="btn btn-primary btn-sm col-sm-3 m-2 text-light"
              >
                Give to a specific area
              </Link>
              <a
                href="https://giving.younglife.org/WV49Plan"
                target="_blank"
                rel="noreferrer noopener"
                className="btn btn-primary btn-sm  col-sm-3 m-2 text-light"
              >
                Give to WV Young Life
              </a>
            </div>
            <h4 className=" text-primary fw-bold mt-5">
              Scroll to find out more.
            </h4>
          </div>
        </div>
        <div className="card container px-4 py-5 my-3 text-center">
          <div>
            <h1 className="display-6 text-primary fw-bold lh-1 mb-3">
              What is The 49 Plan?
            </h1>
            <span className="text-secondary">
              The 49 Plan aims to reconnect, reengage, and refresh West Virginia
              expats who have moved away from WV but haven’t moved on from WV.
              We want to catch up with those people, invite them into West
              Virginia Young Life, and share with them how their involvement was
              used by God for his glory and the good of kids in West Virginia.
              <br />
              <br />
              <h4 className="text-primary">
                So then, what is Young Life in West Virginia?
              </h4>
              <br />
              Young Life in West Virginia is about one thing: Introducing
              adolescents to Jesus Christ and helping them grow in their faith.
              We make that introduction by going where kids are and building
              personal relationships with them and earning the right to be
              heard. We help them grow in their faith by inviting them to
              personally respond to the Good News and see how a relationship
              with Jesus impacts all areas of their life.
              <br />
              <br />
              Young Life in West Virginia is on the move! Volunteers and Staff
              have made Young Life and its programs available for adolescents at
              126 WV schools in 36 counties, a sevenfold increase in the last 14
              years, with a prayerful intent to be in the remaining counties in
              the next 7-10 years. Young Life leaders know 14,793 kids by name,
              which is 12% of adolescents in WV.
              <br />
              <br />
              <h4 className="text-primary">How can I get involved?</h4>
              <br />
              <h5 className="text-secondary">
                <strong>
                  We are in need of prayers, contacts, and funding.
                </strong>
              </h5>
              <br />
              It takes $2.9M to run YL across WV. We run lean and raise all
              operating costs locally. The gap between giving and costs has
              increased about 1% per year over the last 3 years. As a
              supplemental source of revenue, we are looking outside WV, hoping
              to find Mountaineers who now live in the other 49 states and want
              to invest in kids’ futures. Right now, a donation of $196 per year
              delivers all that YL offers to a kid.
              <br />
              <br />
              <p className="text-primary">
                Our current goal is to raise $100K in supplemental funding from
                49’ers to bridge the gap between the generous gifts we receive
                and the costs to accomplish our mission.
              </p>
              <br />
              The 49 Plan will be administrated by YL staff in WV in concert
              with various national YL departments including Fundraising, Data,
              Marketing, and Grants. We also have a representative from each
              county serving on a 49 Plan steering Committee.
            </span>
          </div>
        </div>
        <div className="card container px-4 py-2 my-3 text-center">
          <div className="row g-4 py-5 align-items-center">
            <div className="feature col">
              <div className="feature-icon bg-primary bg-gradient">
                <img src={dollars} alt="Hand Heart" width="50" />
              </div>
              <h5 className="text-secondary">Total Regional Budget</h5>
              <p className="text-secondary">$2.9M</p>
            </div>
            <div className="feature col">
              <div className="feature-icon bg-primary bg-gradient">
                <img src={people} alt="Hand Heart" width="50" />
              </div>
              <h5 className="text-secondary">Total Kids reached</h5>
              <p className="text-secondary">14,793 ($196/kid)</p>
            </div>
            <div className="feature col">
              <div className="feature-icon bg-primary bg-gradient">
                <img src={wagon} alt="Hand Heart" width="50" />
              </div>
              <h5 className="text-secondary">Counties Left to Go</h5>
              <p className="text-secondary">19</p>
            </div>
          </div>
        </div>
        <div className="card container px-4 py-5 my-3 text-center">
          <div className="card-body text-secondary">
            <h3 className="card-title">Featured Story</h3>
            <p className="card-text">
              A kid that graduated about 2 years ago called me up to grab lunch. This kid came to camp the summer of his senior year, and he told me that he didn't want a relationship with God. 
              He went away to college, eventually joined the work force, and we stayed in touch. When we sat down at lunch he began talking about going back to church and said,
               "just over time, all those conversations that we had and that I had with others, <em>what they said became real to me</em>." 
              <br /><br />
              We're not in this for quick results, we are in this to share our lives with kids. We're in it for the long haul, and we will die trying.

 

Because of you, THIS gets to happen in Barbour County. We thank God for every way you have supported our mission! </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Landing;
